import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex max-h-full flex-col" }

import { Ref, nextTick, ref } from 'vue';
import CategorySidemenuHeader from '@/components/CategorySidemenu/CategorySidemenuHeader/CategorySidemenuHeader.vue';
import CategorySidemenuList from '@/components/CategorySidemenu/CategorySidemenuList.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CategorySidemenu',
  emits: {
  navigate: null,
},
  setup(__props, { emit }) {



const list: Ref<HTMLElement | null> = ref(null);

const categorySidemenuListEffect = (element: HTMLElement): void => {
  nextTick((): void => {
    list.value?.scrollTo({
      top: element.offsetTop - list.value.offsetTop,
      behavior: 'smooth',
    });
  });
};

const categorySidemenuListNavigate = (): void => {
  emit('navigate');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CategorySidemenuHeader),
    _createElementVNode("div", {
      ref_key: "list",
      ref: list,
      class: "overflow-y-scroll"
    }, [
      _createVNode(CategorySidemenuList, {
        onEffect: categorySidemenuListEffect,
        onNavigate: categorySidemenuListNavigate
      })
    ], 512)
  ]))
}
}

})